import { DOCUMENTS_NEEDED_LIST } from '../constants/'

const getDocumentsMissing = documents => {
  const documentsMissing = [...DOCUMENTS_NEEDED_LIST]

  if (documents) {
    documents.forEach(document => {
      if (documentsMissing.includes(document.type)) {
        const index = documentsMissing.indexOf(document.type)
        documentsMissing.splice(index, 1)
      }
    })
  }

  return documentsMissing
}

export { getDocumentsMissing }
